import { SelectedQuestion } from '../../components/Modals/AddSurveyModal/addSurveyInterface';
import apiFetch from '../apiFetch';
import generateHeaders from '../myHeaders';

const setupSurveyContent = (
    surveyId: number,
    clientCode: string,
    selectedQuestions: SelectedQuestion[],
    selectedFilters: SelectedQuestion[],
    selectedSchema: string,
): Promise<unknown> => {
    const payload = { client_code: clientCode, selectedQuestions, selectedFilters };

    return apiFetch(
        `${process.env.REACT_APP_API_URL}/configuration/surveys/${surveyId}`,
        { method: 'POST', headers: generateHeaders(selectedSchema), body: JSON.stringify(payload) },
    );
};

export default setupSurveyContent;
